import { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import ProgressBar from "../components/ProgressBar";
import '../App.css';

export default function ResultPageAutism() {
    const location = useLocation();
    const wrapperRef = useRef();
    const lastSentHeight = useRef(0);
    const [scores, setScores] = useState(location.state?.scores || null);
    const reversedQuestionIndex = 5;

    useEffect(() => {
        const savedScores = localStorage.getItem('scoresAutism');
        if (!scores) {
            if (savedScores) {
                setScores(JSON.parse(savedScores));
                localStorage.removeItem('scoresAutism');
            }
        }

    const observer = new ResizeObserver(() => {
      const height = wrapperRef.current?.scrollHeight;
      if (height && Math.abs(height - lastSentHeight.current) > 20) {
        window.parent.postMessage(
          { type: "setHeight", height: height },
          "*"
        );
        lastSentHeight.current = height;
      }
    });
    window.parent.postMessage(
        { type: "quizCompleted", test: "autism_quiz" },
        "*"
    );
     if (wrapperRef.current) observer.observe(wrapperRef.current);
     if (savedScores) {
        localStorage.removeItem('scoresAutism');
     }
    return () => observer.disconnect();
    
    }, [scores]);

    const getResultText = (score) => {
    if (score < 15) {
        return (<><h3>Låg sannolikhet för autism</h3><p>Dina svar på detta test indikerar att du upplever få eller inga symtom som är förknippade med autism. Det är ej sannolikt att autismproblematik föreligger.</p></>);
    } else if (score < 30) {
        return (<><h3>Medelhög sannolikhet för autism</h3><p>Dina svar på detta test indikerar att du upplever några symtom som är förknippade med autism. Det är dock inte säkert att autism är orsaken till de symtom som du upplever, och dessa symtom förekommer även hos personer utan autism i varierande frekvens.</p></>);
    } else if (score < 43) {
        return (<><h3>Hög sannolikhet för autism</h3><p>Dina svar på detta test indikerar att du upplever många av de symtom som är förknippade med autism. Det är dock inte säkert att autism är orsaken till de symtom som du upplever.</p></>);
    } else {
        return (<><h3>Mycket hög sannolikhet för autism</h3><br /><p>Dina svar tyder på många autistiska drag. Kontakta en specialist för vidare utredning.</p></>);
    }
};

    if (!scores ) {
    return <p>Laddar resultat...</p>;
    }

    return (
        <div ref={wrapperRef} className="questionnaire-adhd">
            <div className="results">
                <h2>Resultat</h2>
                <ProgressBar
                    current={Object.entries(scores).reduce((sum, [question, val], idx) => {
                    if (idx === reversedQuestionIndex) {
                        return sum + (3 - val);
                    }
                    return sum + val;
                }, 0)}
                total={42}
                />
                <div>
                {getResultText(
                    Object.entries(scores).reduce((sum, [question, val], idx) => {
                        if (idx === reversedQuestionIndex) {
                            return sum + (3 - val);
                        }
                        return sum + val;
                    }, 0)
                )}
            </div>
            <h3>Kom ihåg</h3>
            <ul className="results-reminder">
                <li>Ett testresultat är inte lika med en diagnos.</li>
                <li>Ett testresultat är inte nödvändigtvis helt rättvisande för just dig.</li>
                <li>Om du mår dåligt bör du söka hjälp oavsett vilket resultat du får.</li>
            </ul>
            </div>
        </div>
    )
}